import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import DoctorDashboardPage from './pages/DoctorDashboardPage';
import SponsorDashboardPage from './pages/SponsorDashboardPage';
import SurveysPage from './pages/SurveysPage';
import SurveyBuilderPage from './pages/SurveyBuilderPage';
import UsersPage from './pages/UsersPage';
import AnalyticsPage from './pages/AnalyticsPage';
import SurveyAnalyticsPage from './pages/SurveyAnalyticsPage';
import SurveyResponsePage from './pages/SurveyResponsePage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProtectedRoute from './components/ProtectedRoute';

// Check if user is authenticated for root redirect
const RootRedirect = () => {
  const token = localStorage.getItem('token');
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  const user = localStorage.getItem('user');
  
  if (token && isAuthenticated) {
    // Check user role and redirect accordingly
    try {
      const userData = JSON.parse(user);
      if (userData?.role === 'administrator') {
        return <Navigate to="/dashboard" replace />;
      } else if (userData?.role === 'sponsor' || userData?.role === 'agency') {
        return <Navigate to="/sponsor" replace />;
      } else {
        return <Navigate to="/doctor" replace />;
      }
    } catch {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return <Navigate to="/auth" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/doctor" element={<ProtectedRoute><DoctorDashboardPage /></ProtectedRoute>} />
          <Route path="/sponsor" element={<ProtectedRoute><SponsorDashboardPage /></ProtectedRoute>} />
          <Route path="/surveys" element={<ProtectedRoute><SurveysPage /></ProtectedRoute>} />
          <Route path="/surveys/:surveyId/builder" element={<ProtectedRoute><SurveyBuilderPage /></ProtectedRoute>} />
          <Route path="/surveys/:surveyId/analytics" element={<ProtectedRoute><SurveyAnalyticsPage /></ProtectedRoute>} />
          <Route path="/surveys/:surveyId/respond" element={<ProtectedRoute><SurveyResponsePage /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
